<template>
  <pt-hospital-manage class="pt-hospital-manage__page"></pt-hospital-manage>
</template>

<script>
import PtHospitalManage from 'cps/hospital-and-doctor-manage/pt-hospital-manage/withData'
export default {
  name: 'pt-hospital-manage__view',
  components: {
    'pt-hospital-manage': PtHospitalManage
  }
}
</script>
